import React, { useMemo } from 'react';
import classNames from 'classnames';
import QuestionCollapsible from '../QuestionCollapsible';
import { QualificationQuestionType } from 'models/DealRoom';
import DraggableCard from 'components/DraggableCard';

import './QualificationQuestion.styles.scss';
import './QualificationQuestion.styles.responsive.scss';

type QualificationQuestionProps = {
  className?: string;
  id: string;
  question: QualificationQuestionType;
  isReordering: boolean;
  setIsReordering: React.Dispatch<React.SetStateAction<boolean>>;
};

const QualificationQuestion: React.FC<QualificationQuestionProps> = (props) => {
  const {
    className,
    id,
    isReordering,
    question: { title, answers },
    setIsReordering,
  } = props;

  const classes = classNames('qualification-question', className);

  const trigger = useMemo(() => <p>{title}</p>, [title]);

  const Content = useMemo(() => {
    return (
      <QuestionCollapsible
        className={classes}
        trigger={trigger}
        setIsReordering={setIsReordering}
      >
        {answers.map(({ answer }) => (
          <div key={answer} className="answer">
            {answer}
          </div>
        ))}
      </QuestionCollapsible>
    );
  }, [answers, classes, trigger, setIsReordering]);

  return (
    <DraggableCard id={id} dragEnabled={isReordering}>
      {Content}
    </DraggableCard>
  );
};

export default QualificationQuestion;
